import { useDispatch } from 'react-redux';

import type { AppDispatch } from '#apps/client-web/app/store/store';

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
